import { deviceViewPacketDetailsEntityId } from 'components/DeviceView/deviceViewTypes';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { changePathLookupPathInspectorActiveNode } from './changePathLookupPathInspectorActiveNode';

export const changePathInspectorActiveNodeOnShowEdgeDetail: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    const { highlightedEdges } = cmdContext.getState().pathlookup.pathInspector;
    if (Object.keys(highlightedEdges).length > 0) {
      dispatch(changePathLookupPathInspectorActiveNode, {
        deviceViewEntityId: deviceViewPacketDetailsEntityId,
      });
    }
  };
